import styled from "styled-components";

export const PhoneWrapper = styled.div`
  width: 100%;

  .react-international-phone-input-container {
    width: 100%;
    display: flex !important;
    align-items: stretch !important;
    position: relative;
  }

  .react-international-phone-input-container input {
    width: 100%;
    border-bottom-right-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    border-left: 1px solid #ECECEC !important;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    padding-left: 0.75rem !important;
    border-color: ${(props) => props.theme.colors.border};
  }

  /* Estilizar el selector de país para que se distinga claramente como prefijo */
  .react-international-phone-country-selector-button {
    cursor: pointer !important;
    user-select: none !important;
    background-color: #F2F3F7 !important;
    border: 1px solid #ECECEC !important;
    border-right: 1px solid #D1D5DB !important;
    border-top-left-radius: 0.5rem !important;
    border-bottom-left-radius: 0.5rem !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    padding: 0.625rem 0.75rem !important;
    margin-right: 0 !important;
    font-weight: 500 !important;
    color: #565869 !important;
    min-width: 4rem !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .react-international-phone-country-selector-button:focus {
    outline: none !important;
    background-color: #E5E7EB !important;
  }

  .react-international-phone-country-selector-button:hover {
    background-color: #E5E7EB !important;
  }

  /* Estilizar el código de país dentro del selector para que se vea gris */
  .react-international-phone-country-selector-button .react-international-phone-country-selector-button__button-content {
    color: #989898 !important;
    font-weight: 400 !important;
  }

  .react-international-phone-country-selector-button span {
    color: #989898 !important;
  }

  /* Estilizar el código de país que aparece en el input (el +34) para que se vea gris y separado */
  .react-international-phone-input-container .react-international-phone-dial-code-preview {
    color: #989898 !important;
    font-weight: 400 !important;
    margin-right: 0.75rem !important;
    pointer-events: none !important;
    user-select: none !important;
    opacity: 0.8 !important;
    padding-right: 0.5rem !important;
    border-right: 1px solid #E5E7EB !important;
  }
`;
